import loyalty from "./HttpRequestLoyalty";

  function  getInfo(token){
        return loyalty.get('/v3/customer', { headers: {'Authorization': "Bearer "+token}});
    }
    function getBenefit(){
        return loyalty.get('/v3/benefit');
    }
    function  getCondition(){
        return loyalty.get('/v3/condition');
    }
    export {getInfo,getBenefit,getCondition}